import { render, staticRenderFns } from "./VxCellRarityBadge.vue?vue&type=template&id=6718e3f7&"
import script from "./VxCellRarityBadge.vue?vue&type=script&lang=js&"
export * from "./VxCellRarityBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports